const SEND_REQUEST = 'contact/demand/SEND_REQUEST';

export default {
  SEND_REQUEST,
};
